var _circle, _path, _path2, _ellipse;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#FF7A00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.24967 3.33398H9.74967C11.3603 3.33398 12.6663 4.64007 12.6663 6.25065V9.75065C12.6663 11.3612 11.3603 12.6673 9.74967 12.6673H6.24967C4.63909 12.6673 3.33301 11.3612 3.33301 9.75065V6.25065C3.33301 4.64007 4.63909 3.33398 6.24967 3.33398ZM9.74967 11.7923C10.8755 11.7923 11.7913 10.8765 11.7913 9.75065V6.25065C11.7913 5.12482 10.8755 4.20898 9.74967 4.20898H6.24967C5.12384 4.20898 4.20801 5.12482 4.20801 6.25065V9.75065C4.20801 10.8765 5.12384 11.7923 6.24967 11.7923H9.74967Z",
    fill: "#F8F9FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.66602 8.0013C5.66602 6.71272 6.71077 5.66797 7.99935 5.66797C9.28793 5.66797 10.3327 6.71272 10.3327 8.0013C10.3327 9.28989 9.28793 10.3346 7.99935 10.3346C6.71077 10.3346 5.66602 9.28989 5.66602 8.0013ZM6.54102 8.0013C6.54102 8.80514 7.19552 9.45964 7.99935 9.45964C8.80318 9.45964 9.45768 8.80514 9.45768 8.0013C9.45768 7.19689 8.80318 6.54297 7.99935 6.54297C7.19552 6.54297 6.54102 7.19689 6.54102 8.0013Z",
    fill: "#F8F9FA"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.5082,
    cy: 5.49256,
    rx: 0.310917,
    ry: 0.310916,
    fill: "#F8F9FA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeInstagram);
export default __webpack_public_path__ + "static/media/homeInstagram.333f270c7129eeb9c33531f941a25025.svg";
export { ForwardRef as ReactComponent };